// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"14":"7022d2499c55b020","112":"5c5ddfddc4672f7a","579":"d017d67a8ad47712"}[chunkId] + ".js";
};